import React from 'react';
import { Container } from './styles';

// import smileImage from '~/assets/tv/november-2025/5.jpg';
import smileImage from '~/assets/tv/october-2025/TV3.jpg'; // TODO: placeholder, trocar pela imagem de novembro

interface IChangeYourSmile5Props {
  show: boolean;
  startAnim: boolean;
}

const ChangeYourSmile5: React.FC<IChangeYourSmile5Props> = ({
  show,
  startAnim,
}) => {
  return (
    <Container show={show} startAnim={startAnim}>
      <img className="bg" src={smileImage} alt="chega de esconder o Sorriso" />
    </Container>
  );
};

export default ChangeYourSmile5;
